import connectAutocomplete, {
	type AutocompleteConnectorParams,
	type AutocompleteWidgetDescription
} from "instantsearch.js/es/connectors/autocomplete/connectAutocomplete";
import { useConnector } from "react-instantsearch";

/**
 * Custom hook to use the Algolia Autocomplete connector.
 */
export function useAutocomplete(): ReturnType<
	typeof useConnector<
		AutocompleteConnectorParams,
		AutocompleteWidgetDescription
	>
> {
	return useConnector<
		AutocompleteConnectorParams,
		AutocompleteWidgetDescription
	>(connectAutocomplete);
}
